import React from 'react';

import CloseIcon from 'icons/close-2.svg';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';

import ModalBox from 'components/application/ModalBox';

import Uploader from 'components/uploader/Uploader';

export default function AttachmentUploadModal({
  modalContainerSelector,
  onModalClose,
  onUpload,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'attachments.components.AttachmentUploadModal',
  });

  const modalContent = (
    <ModalBox
      isOpen={true}
      modalBoxClassName='tw-h-100 tw-w-140'
      mode='flexible'
      onClose={onModalClose}
      withFooter={false}
    >
      <div
        className='tw-flex tw-items-center tw-justify-between tw-p-6'
        data-element-name='content'
      >
        <h1 className='tw-my-0 tw-text-xl tw-font-semibold'>
          {i18nT('title')}
        </h1>
        <div
          className='tw-cursor-pointer'
          data-element-name='close-modal'
          onClick={onModalClose}
        >
          <CloseIcon
            className='tw-h-5 tw-w-5 tw-text-grey-500 hover:tw-text-grey-900'
            height={20}
            width={20}
          />
        </div>
      </div>

      <div className='tw-p-4 tw-pt-0'>
        <Uploader
          className='tw-h-[294px] tw-w-full'
          externalInputProps={{ name: 'attachments[files]' }}
          iconDimensions='md'
          onCancel={onModalClose}
          onUpload={onUpload}
        />
      </div>
    </ModalBox>
  );

  if (modalContainerSelector) {
    const portalTarget = document.querySelector(modalContainerSelector);
    if (portalTarget) {
      return ReactDOM.createPortal(modalContent, portalTarget);
    }
  }

  return modalContent;
}

AttachmentUploadModal.propTypes = {
  modalContainerSelector: PropTypes.string,
  onModalClose: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
};
